import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'channelName',
      type: 'input',
      label: '渠道名称',
      placeholder: '请输入渠道名称'
    }
  ]
}
